// extracted by mini-css-extract-plugin
export default {"dashboardTable":"userForm_dashboardTable__mbqad","table_popup":"userForm_table_popup__siEB9","visible":"userForm_visible__PBQd2","aling_btn":"userForm_aling_btn__3I1RH"};